import React, { useState } from 'react';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { Footer } from './Footer';
import { Dashboard } from '../../pages/Dashboard';
import { TransactionMonitoring } from '../../pages/TransactionMonitoring';
import { TransactionSearch } from '../../pages/TransactionSearch';
import { RoleManagement } from '../../pages/management/RoleManagement';
import { UserManagement } from '../../pages/management/UserManagement';
import { Configurations } from '../../pages/Configurations';
import { TransactionReport } from '../../pages/reports/TransactionReport';
import { TransactionSummaryReport } from '../../pages/reports/TransactionSummaryReport';
import { UserListReport } from '../../pages/reports/UserListReport';
import { UserActivityAuditLog } from '../../pages/reports/UserActivityAuditLog';
import { AuditLog } from '../../pages/AuditLog';
import { BulkPayments } from '../../pages/batch/BulkPayments';
import { BulkReceiving } from '../../pages/batch/BulkReceiving';
import { CertificateManagement } from '../../pages/security/CertificateManagement';
interface AppShellProps {
  onLogout: () => void;
}
export function AppShell({
  onLogout
}: AppShellProps) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [currentPath, setCurrentPath] = useState('dashboard');
  const handleNavigate = (path: string) => {
    setCurrentPath(path);
  };
  const renderContent = () => {
    switch (currentPath) {
      case 'dashboard':
        return <Dashboard data-id="element-100" />;
      case 'transactions/monitoring':
        return <TransactionMonitoring data-id="element-101" />;
      case 'transactions/search':
        return <TransactionSearch data-id="element-102" />;
      case 'management/roles':
        return <RoleManagement data-id="element-103" />;
      case 'management/users':
        return <UserManagement data-id="element-104" />;
      case 'configurations':
        return <Configurations data-id="element-105" />;
      case 'batch/payments':
        return <BulkPayments data-id="element-106" />;
      case 'batch/collections':
        return <BulkReceiving data-id="element-107" />;
      case 'reports/transactions':
        return <TransactionReport data-id="element-108" />;
      case 'reports/summary':
        return <TransactionSummaryReport data-id="element-109" />;
      case 'reports/users':
        return <UserListReport data-id="element-110" />;
      case 'reports/user-activity':
        return <UserActivityAuditLog data-id="element-111" />;
      case 'audit-log':
        return <AuditLog data-id="element-112" />;
      case 'security/certificates':
        return <CertificateManagement data-id="element-113" />;
      default:
        return <div className="flex items-center justify-center h-full" data-id="element-114">
            <div className="text-center p-8" data-id="element-115">
              <h2 className="text-2xl font-semibold text-gray-700 mb-4" data-id="element-116">
                {currentPath.split('/').pop()?.replace(/-/g, ' ')}
              </h2>
              <p className="text-gray-500" data-id="element-117">This page is under construction</p>
            </div>
          </div>;
    }
  };
  return <div className="flex flex-col min-h-screen bg-gray-50" data-id="element-118">
      <Header isAuthenticated={true} onLogout={onLogout} data-id="element-119" />
      <div className="flex flex-1 overflow-hidden" data-id="element-120">
        <Sidebar collapsed={sidebarCollapsed} onToggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)} onNavigate={handleNavigate} activePath={currentPath} data-id="element-121" />
        <main className="flex-1 overflow-auto p-6" data-id="element-122">{renderContent()}</main>
      </div>
      <Footer data-id="element-123" />
    </div>;
}